import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { ExecutionsHeaderTiles, ExecutionsTable } from '../../containers'
import { executionOperations } from '../../../../state/ducks/executions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ExecutionShape, PaginationShape } from '../../../../prop-types'

class ExecutionsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchExecutions = this.fetchExecutions.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchExecutions()
  }

  fetchExecutions () {
    this.props.fetchExecutions(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchExecutions())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Executions</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Executions'} subTitle={'All executions'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <ExecutionsHeaderTiles all_executions={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchExecutions}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All executions</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <ExecutionsTable executions={this.props.executions}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </ExecutionsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
ExecutionsPage.propTypes = {
  executions: arrayOf(ExecutionShape).isRequired,
  fetchExecutions: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
ExecutionsPage.defaultProps = {
  executions: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.executions.fetchExecutionsReducer.loading,
  executions: state.executions.fetchExecutionsReducer.data.results,
  paginationData: state.executions.fetchExecutionsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchExecutions: executionOperations.list
}

// Export Class
const _ExecutionsPage = connect(mapStateToProps, mapDispatchToProps)(ExecutionsPage)
export { _ExecutionsPage as ExecutionsPage }
